import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XCircleIcon } from "@heroicons/react/24/solid";
import CloseIconButton from "./CloseIconButton";

const CameraFormModal = ({
  isCloseHide = false,
  children,
  isOpen,
  onClose,
  title,
  width = "4/5",
  hasCloseButton = true,
  className,
  closeOutside = true,
  modalFilterStat,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-20 bg-black bg-opacity-40"
        onClose={() => {}}
      >
        <div className="flex min-h-full items-center justify-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div
              className={`relative sm:w-4/5 md:w-7/5 lg:w-auto inline-block border-primary border-l-6 px-4 pb-3 pt-2 overflow-visible  
              text-left align-middle transition-all 
              transform bg-white shadow-xl brContainer ${className} `}
            >
              {isCloseHide ? (
                <></>
              ) : (
                <CloseIconButton onClick={() => onClose()} />
              )}
              <div>{children}</div>
              {hasCloseButton && (
                <div className="flex justify-end mt-3 mr-1">
                  <button
                    className="px-3 py-1 text-xs text-white gap-x-2 bg-btnClose rounded-full flex items-center 
                    justify-center font-semibold hover:bg-gray-400 box-shadow"
                    onClick={onClose}
                  >
                    <XCircleIcon className="h-4 w-4" />
                    <div>Close</div>
                  </button>
                </div>
              )}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default CameraFormModal;
